<template>
    <div class="page">
        <ion-grid>
            <ion-row class="search-view">
                <ion-col>
                <ion-row align-items-stretch>
                    <ion-col size="12" size-md="2">
                    <ion-label>Corporate Name</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-input
                        class="form-input"
                        type="text"
                        id="corporateName"
                        @input="corporateName = $event.target.value"
                        maxlength="100"
                        ></ion-input>
                    </div>
                    </ion-col>
                    <ion-col size="12" size-md="2">
                    <ion-label>Branch Name</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-input
                        class="form-input"
                        type="text"
                        id="branch"
                        @input="branch = $event.target.value"
                        :value =branch
                        maxlength="100"
                        ></ion-input>
                    </div>
                    </ion-col>
                    <ion-col size="12" size-md="2">
                    <ion-label>Branch ID</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-input
                        class="form-input"
                        type="text"
                        id="branchId"
                        @input="branchId = $event.target.value"
                        :value = branchId
                        maxlength="50"
                        ></ion-input>
                    </div>
                    </ion-col>
                    <ion-col size="12" size-md="2">
                    <br />
                    <ion-button class="btn-search margin-top-10" @click="searchBranches">Search</ion-button>
                    <ion-button class="btn-clear margin-top-10" @click="clearFields">
                        <ion-icon :icon= "refresh"></ion-icon>
                    </ion-button>
                    </ion-col>
                </ion-row>
                </ion-col>
            </ion-row>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="list-view">
                <ion-col>
                <ion-row class="list-head">
                    <ion-col size="12" size-md="2">
                    <ion-label>Branch ID</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="2">
                    <ion-label>Corpoarate ID</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="2">
                    <ion-label>Corpoarate Name</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="2">
                    <ion-label>Branch Name</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="2">
                    <ion-label>GST#</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="2">
                    <ion-label>Status</ion-label>
                    </ion-col>
                </ion-row>
                <hr />

                <ion-row class="list-item" v-for="(corporate) in this.corporates" :key="corporate">
                    <ion-col size="12" size-md="2">
                    <ion-label class="ext-link" @click="viewBranchDetails(corporate)">{{corporate.branchId}}</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="2">
                    <ion-label>{{corporate.corporateId}}</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="2">
                    <ion-label>{{corporate.corporateName}}</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="2">
                    <ion-label>{{corporate.branch}}</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="2">
                    <ion-label>{{corporate.gstNumber}}</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="2">
                    <ion-label v-bind:class="[{'active': corporate.status.code == 'A'}, {'in-active': corporate.status.code == 'RET'}]">{{convertUppercase(corporate.status.description)}}</ion-label>
                    </ion-col>
                </ion-row>
                </ion-col>
            </ion-row>
            <ion-row class="row-divider"></ion-row>
            <ion-row v-if="norecordsfound">
                <ion-col size="12" class="ion-text-center">
                    <ion-label class="pagination-info">No records found for the selected filters</ion-label>
                </ion-col>
            </ion-row>
            <ion-row v-else>
                <ion-col size="12" size-md="5">
                <ion-label
                    class="pagination-info"
                >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
                </ion-col>
                <ion-col size="12" size-md="7" class="ion-text-right">
                    <div class="pagination">
                        <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
                        <a class="prev disabled" v-else>Prev</a>
                        <a
                        
                        v-for="page in this.pagesList"
                        :key="page"
                        v-bind:class="{'active': pageNo == page}"
                        @click="loadPage(page)"
                        >{{page}}</a>
                        <a
                        
                        class="next"
                        v-if="this.pageNo < this.totalPages"
                        @click="loadPage(pageNo + 1)"
                        >Next</a>
                        <a class="next disabled" v-else>Next</a>
                    </div>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { refresh } from 'ionicons/icons';
import { EVCStationService } from "../../service/evcstation/stations.service";
import { EVCStation, EVCStationStatus } from "../../entity/location/evcstation";
import { migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";
import { PaginationUtils } from "../../util/pagination-utils";

// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datepicker from 'vue3-datepicker';
import { CorporateService } from "../../service/corporate/corporate.service";
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSpinner } from "@ionic/vue";

export default defineComponent ({
    name: 'branchCPO',
    components: {
        datepicker, IonGrid, IonRow, IonCol, IonLabel, IonInput, IonButton, IonIcon, IonSpinner
    },
    data() {
        return {
            refresh,
            loaderTab: true,
            corporates: [],
            statuses: [],
            corporateId: "",
            corporateName: "",
            branch: "",
            gstNumber: "",
            status: "",
            norecordsfound: true,
            totalRecords: 0,
            pageRecords: 15,
            pageNo: 1,
            pagesList: [],
            totalPages: 0,
            branchId: "",
            fromAdminOrNot : ""
        }
    },
    async mounted() {
        try {
            this.fromAdminOrNot = localStorage.getItem('fromAdminDashboard')
            if(this.fromAdminOrNot == 'Y') {
                // this.branchId = this.$route.params.branchId;
                let brId = (localStorage.getItem("branchId"));
                if(brId) {
                    this.branchId = brId
                }
                await this.searchBranches();
                this.loaderTab = false;
            } else {
                this.statuses = await new CorporateService().getBranchStatus();
                var page = localStorage.getItem('branchPage');
                if(page) {
                    this.pageNo = Number(page);
                }
                var search = localStorage.getItem('branchSearch');
                if(search) {
                    await this.searchBranches();
                }
                this.loaderTab = false;
            }
        } catch(error) {
            this.loaderTab = false;
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        }
        
    },
    methods: {
        convertUppercase(value) {
            return value.toUpperCase()
        },
        viewBranchDetails(corporateInfo) {
            if(this.fromAdminOrNot) {
                localStorage.setItem('branchInfoForDashboard', JSON.stringify(corporateInfo));
                localStorage.setItem('branchId', corporateInfo.branchId);
                localStorage.removeItem('fromAdminDashboard');
                this.$router.push({
                name: "adminDashboard"
                });
                // this.$router.go(-1)
                
            } else {
                localStorage.removeItem('userBranchSearch');
                // let save data in local storage 13052022
                let branchInfo = {
                corporateId: corporateInfo.corporateId,
                branchId: corporateInfo.branchId,
                corporateName: corporateInfo.corporateName,
                branch: corporateInfo.branch
                }
                localStorage.setItem('branchInfo', JSON.stringify(branchInfo));
                this.$router.push({
                name: "branchDetails",
                params: { corporateId: corporateInfo.branchId }
                });
            }
        
        },
        clearFields() {
            this.corporateName = null;
            this.branchId = null;
            this.branch = null;
            document.getElementById("corporateName").value = null;
            document.getElementById("branchId").value = null;
            document.getElementById("branch").value = null;
            localStorage.removeItem('branchSearch');
            localStorage.removeItem('branchPage');
            this.corporates = [];
            this.norecordsfound = true;
        },

        async searchBranches() {
            try {
                localStorage.removeItem('branchPage');
                this.pageNo = 1;
                localStorage.setItem("branchSearch", JSON.stringify({corporateName: this.corporateName, id: this.branchId,  branch: this.branch}))
                this.loaderTab = true;
                let result = await new CorporateService().corporateAtPageByPaginatedWithSizeMatchingQuery(
                    this.pageNo,
                    this.pageRecords,
                    {
                    corporateName: this.corporateName,
                    id: this.branchId,
                    branch: this.branch
                    }
                );
                if(result.data.length != 0) {
                    this.totalRecords = result.meta.totalrecords;
                    this.corporates = result.data;
                    (this.pagesList = new PaginationUtils().getPagesList(
                    this.totalRecords,
                    this.pageRecords,
                    this.pageNo
                    )),
                    (this.totalPages = new PaginationUtils().getTotalPages(
                    this.totalRecords,
                    this.pageRecords
                    ));
                    this.norecordsfound = false;
                    this.loaderTab = false;
                } else {
                    this.corporates = [];
                    this.norecordsfound = true;
                    this.loaderTab = false;
                }
            } catch(error) {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },

        async loadPage(page) {
            localStorage.setItem('branchPage', page);
            this.loaderTab = true;
            this.pageNo = page;
            this.pagesList = new PaginationUtils().getPagesList(
                this.totalRecords,
                this.pageRecords,
                page
            );
            let result = await new CorporateService().corporateAtPageByPaginatedWithSizeMatchingQuery(
                this.pageNo,
                this.pageRecords,
                {
                corporateName: this.corporateName,
                id: this.branchId,
                branch: this.branch
                }
            );
            if(result.data.length != 0) {
                this.totalRecords = result.meta.totalrecords;
                this.corporates = result.data;
                (this.pagesList = new PaginationUtils().getPagesList(
                this.totalRecords,
                this.pageRecords,
                this.pageNo
                )),
                (this.totalPages = new PaginationUtils().getTotalPages(
                this.totalRecords,
                this.pageRecords
                ));
                this.norecordsfound = false;
                this.loaderTab = false;
            } else {
                this.corporates = [];
                this.norecordsfound = true;
                this.loaderTab = false;
            }
        }
    }
})
</script>

<style scoped>
.select-box {
  position: relative;
  max-width: 317px;
  width: 100%;
  display: inline-block;
  margin-right: 16px;
}

.select-box ion-select {
  max-width: 317px;
  width: 100%;
  height: 34px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  border-radius: 4px;
  opacity: 1;
  padding: 12px;
  padding-top: 13px;
  text-align: left;
  font-size: 14px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  line-height: 26px;
  color: #202020;
}

.select-box .custom-select-placeholder {
  font-size: 14px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
  position: absolute;
  z-index: 99;
  top: 18px;
  left: 18px;
}

.select-box .custom-select-icon {
  position: absolute;
  z-index: 99;
  top: 6px;
  background: #fff;
  right: 15px;
}
</style>